import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import { Button, Flex, Typography } from 'antd';
import { useParams } from 'react-router-dom';

import { getFields, getInitialValues, validationSchema } from '../fields';
import { renderField } from '../../../../promocodes/utils/fields';
import {
    useCreateUnitPayMetatagMutation,
    useLazyReadUnitMetatagQuery,
} from '../../../service/paymentSettings.api';
import { FORM_WIDTH, formikCommonOptions } from '../../../utils/options';
import { useApiErrorNotification } from '../../../../../../../hooks/useApiErrorNotification';
import { useApiSuccessNotification } from '../../../../../../../hooks/useApiSuccessNotification';
import { UnitpayMetatagResponse } from '../../../service/paymentSettings.interface';
import { StepTitle } from '../../steps/StepTitle';
import { StepList } from '../../steps/StepList';
import { useAppSelector } from '../../../../../../../store';
import { selectShopCurrent } from '../../../../shops/store/shopSlice';

const { Text } = Typography;
export const UnitpayStepConnect = () => {
    const current = useAppSelector(selectShopCurrent);

    const [createMetaTag, { isSuccess, isError, error }] =
        useCreateUnitPayMetatagMutation();
    const [getMetaTag, { data: metatag }] = useLazyReadUnitMetatagQuery();

    useApiErrorNotification(isError, error);
    useApiSuccessNotification(isSuccess, {
        message: 'Мета-тэг успешно сохранен',
    });

    useEffect(() => {
        if (current.id) {
            getMetaTag({ shop_id: +current.id }, true);
        }
    }, [current.id]);

    const onSubmit = async (values: UnitpayMetatagResponse) => {
        const data = {
            shop_id: +current.id,
            ...values,
        };

        await createMetaTag(data).unwrap();
    };

    const formik = useFormik({
        initialValues: { ...metatag } || getInitialValues('metatag'),
        validationSchema,
        onSubmit: onSubmit,
        ...formikCommonOptions,
    });

    const currentField = getFields('metatag');

    return (
        <Flex vertical gap={8}>
            <StepTitle text={'Шаг 2. Модерация проекта в Unitpay'} />
            <StepList>
                <Text>1. выберите тип подтверждения проекта "Мета-тэг"</Text>
                <Text>
                    2. скопируйте мета-тэг из Unitpay и вставьте в поле ниже:
                </Text>
            </StepList>

            <Flex vertical style={{ width: FORM_WIDTH }} gap={8}>
                {currentField.map(field => (
                    <React.Fragment key={field.name}>
                        {renderField(field, formik)}
                    </React.Fragment>
                ))}

                <div>
                    <Button
                        disabled={!formik.isValid || !formik.dirty}
                        onClick={() => onSubmit(formik.values)}
                    >
                        Сохранить
                    </Button>
                </div>
            </Flex>

            <StepList>
                <Text>3. перейдите в сервис Unitpay и нажмите "Далее"</Text>
                <Text>
                    4. дождитесь результатов модерации со стороны сервиса
                    Unitpay, статус проекта в Unitpay должен смениться с "На
                    модерации" на "Активен"
                </Text>
            </StepList>
        </Flex>
    );
};
